import { isMobileScreen } from '../../../../../../ui/src';
import { useState } from 'react';
import { ApplicationInsights } from '@microsoft/applicationinsights-web';
import ViewReceiptsModal from '../modals/ViewReceiptsModal';
import { DrawBudgetCategory } from '../functions';
import React from 'react';

interface IReceiptButtonParameters {
    categories: DrawBudgetCategory[];
    applicationInsights: ApplicationInsights;
}
export const ReceiptButton = ({ categories, applicationInsights }: IReceiptButtonParameters): JSX.Element => {
    const [isReceiptModalOpen, set_isReceiptModalOpen] = useState<boolean>(false);

    const mobileScreen = isMobileScreen();

    const ReadOnlyReceiptButton = ({ title }: { title: string }) => {
        return !mobileScreen ? (
            <button
                id='receiptButton'
                className='button primary readOnly'
                title={title}
            >
                Receipts
            </button>
        ) : (
            <></>
        );
    };

    return (
        <>
            {!mobileScreen ? (
                <button
                    id='receiptButton'
                    className='button primary'
                    onClick={() => set_isReceiptModalOpen(true)}
                >
                    Receipts
                </button>
            ) : (
                <></>
            )}
            <ViewReceiptsModal
                key='test'
                categories={categories}
                applicationInsights={applicationInsights}
                isOpen={isReceiptModalOpen}
                close={() => set_isReceiptModalOpen(false)}
            />
        </>
    );
};
